import { Badge } from "@/components/ui/badge";

type View = "shop" | "opening" | "collection" | "hustle" | "battle";

interface NavBarProps {
  currentView: View;
  onNavigate: (view: View) => void;
  coins: number;
  canOpenPacks: boolean;
}

export function NavBar({ currentView, onNavigate, coins, canOpenPacks }: NavBarProps) {
  const tabs: { id: View; label: string; disabled?: boolean; disabledHint?: string }[] = [
    { id: "shop", label: "Shop" },
    {
      id: "opening",
      label: "Open Packs",
      disabled: !canOpenPacks,
      disabledHint: "Open a pack from Shop first",
    },
    { id: "collection", label: "Collection" },
    { id: "hustle", label: "Hustle" },
    { id: "battle", label: "Battle" },
  ];

  return (
    <nav className="w-full border-b bg-card/50 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          <h1 className="text-lg font-bold tracking-tight">
            Mogger Universe
          </h1>
          <Badge variant="outline" className="gap-1.5 px-3 py-1 text-sm">
            <span className="text-yellow-500">&#x1FA99;</span>
            <span className="font-semibold tabular-nums">
              {coins.toLocaleString()}
            </span>
          </Badge>
        </div>

        <div className="flex gap-1 -mb-px">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => {
                  if (!tab.disabled) onNavigate(tab.id);
                }}
                disabled={tab.disabled}
                aria-disabled={tab.disabled}
                title={tab.disabled ? tab.disabledHint : undefined}
                className={`flex-1 px-2 py-2.5 text-xs sm:text-sm font-medium text-center transition-colors border-b-2 ${
                  currentView === tab.id
                    ? "text-foreground border-primary"
                    : "text-muted-foreground border-transparent hover:text-foreground hover:border-muted"
                } ${
                  tab.disabled
                    ? "opacity-45 cursor-not-allowed hover:text-muted-foreground hover:border-transparent"
                    : ""
                }`}
              >
                {tab.label}
              </button>
            ))}
        </div>
      </div>
    </nav>
  );
}
